// Lightweight, privacy-friendly session ID for cross-page attribution
// (joins cta-click → lead-submission events). Stored in localStorage with a
// 30-day rolling TTL so a sponsor who clicks today and converts next week
// still attributes correctly.
const KEY = "pshl_session_id";
const TTL_KEY = "pshl_session_id_expires_at";
const TTL_MS = 30 * 24 * 60 * 60 * 1000;

function uuid() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  // Lightweight RFC4122-v4 fallback
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getSessionId() {
  try {
    const now = Date.now();
    const expires = parseInt(localStorage.getItem(TTL_KEY) || "0", 10);
    let id = localStorage.getItem(KEY);
    if (!id || !expires || expires < now) {
      id = uuid();
    }
    // Sliding window: bump expiry on every read
    localStorage.setItem(KEY, id);
    localStorage.setItem(TTL_KEY, String(now + TTL_MS));
    return id;
  } catch {
    // localStorage may be unavailable (private mode, embedded iframes, etc.)
    return "anon";
  }
}
